import { Button, Layout } from "antd";
import "./App.scss"
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,

} from '@ant-design/icons';
interface IHeader {
  collapsed: boolean,
  setCollapsed: (state: boolean) => void
}
const Header = ({
  collapsed,
  setCollapsed
}: IHeader) => {

  return (
    <Layout.Header style={{ padding: 0, background: "white" }} >
      <Button
        type="text"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={() => setCollapsed(!collapsed)}
        style={{
          fontSize: '16px',
          width: 64,
          height: 64,
        }}
      />

    </Layout.Header >
  );
}

export default Header